import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { listItemWrapper } from '../../../../shared/lib/theme/styleConstants';
import { ActionType } from '../../app/reducer/AppContextReducer';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../app/contexts/AppContext';
import { LABEL_CHANGE_PLAN } from '../../../../shared/lib/constants';

export const EditPlanDetails = () => {
  const { dispatch, isEdit } = useAppContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changePlan = () => {
    dispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit });
    navigate('/change-plan');
    setAnchorEl(null);
  };

  return (
    <Box position="absolute" top="10px" right="10px">
      <IconButton id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        sx={listItemWrapper}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={changePlan}>{LABEL_CHANGE_PLAN}</MenuItem>
      </Menu>
    </Box>
  );
};
